module.exports = __webpack_public_path__ + "img/w1_8.7bb2e839.png";